import React from 'react';
import _ from 'lodash';

export const ICONS = {
  vhigh: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.018 16C12.426 16 15.992 12.418 15.982 8C15.972 3.582 12.39 0 7.982 0C3.574 0 0.008 3.582 0.018 8C0.028 12.418 3.61 16 8.018 16Z" fill="#0B9C23" />
      <path d="M11.173 8.767C11.463 8.84 11.64 9.133 11.567 9.423C11.169 11.019 9.829 12.051 8.154 12.051C6.479 12.051 5.112 10.968 4.74 9.419C4.67 9.128 4.849 8.836 5.14 8.766L11.173 8.767Z" fill="#fff" />
      <path d="M5.624 7.09C6.066 6.986 6.34 6.543 6.236 6.101C6.131 5.659 5.688 5.385 5.246 5.489C4.804 5.594 4.53 6.037 4.635 6.479C4.739 6.921 5.182 7.195 5.624 7.09Z" fill="#fff" />
      <path d="M11.146 6.869C11.467 6.548 11.467 6.027 11.146 5.706C10.824 5.384 10.304 5.384 9.982 5.706C9.661 6.027 9.661 6.548 9.982 6.869C10.304 7.19 10.824 7.19 11.146 6.869Z" fill="#fff" />
    </svg>
  ),
  high: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.018 16C12.426 16 15.992 12.418 15.982 8C15.972 3.582 12.39 0 7.982 0C3.574 0 0.008 3.582 0.018 8C0.028 12.418 3.61 16 8.018 16Z" fill="#3AC34B" />
      <path d="M8 11.357C6.632 11.357 5.41 10.957 4.732 10.287C4.519 10.077 4.517 9.734 4.727 9.522C4.937 9.309 5.28 9.307 5.492 9.516C5.959 9.977 6.943 10.275 8 10.275C9.057 10.275 10.042 9.977 10.508 9.516C10.721 9.306 11.063 9.309 11.273 9.522C11.484 9.734 11.481 10.077 11.268 10.287C10.59 10.957 9.368 11.357 8 11.357Z" fill="#fff" />
      <path d="M6.017 6.869C6.338 6.548 6.338 6.027 6.017 5.706C5.696 5.384 5.175 5.384 4.854 5.706C4.532 6.027 4.532 6.548 4.854 6.869C5.175 7.19 5.696 7.19 6.017 6.869Z" fill="#fff" />
      <path d="M11.378 6.42C11.451 5.971 11.146 5.548 10.698 5.476C10.249 5.403 9.827 5.707 9.754 6.156C9.681 6.604 9.986 7.027 10.434 7.1C10.882 7.172 11.305 6.868 11.378 6.42Z" fill="#fff" />
    </svg>
  ),
  mid: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.018 16C12.426 16 15.992 12.418 15.982 8C15.972 3.582 12.39 0 7.982 0C3.574 0 0.008 3.582 0.018 8C0.028 12.418 3.61 16 8.018 16Z" fill="#FFB600" />
      <path d="M10.888 10.869H5.112C4.813 10.869 4.571 10.627 4.571 10.328C4.571 10.029 4.813 9.787 5.112 9.787H10.888C11.187 9.787 11.429 10.029 11.429 10.328C11.429 10.627 11.187 10.869 10.888 10.869Z" fill="#fff" />
      <path d="M5.569 7.098C6.017 7.025 6.322 6.602 6.249 6.154C6.176 5.705 5.753 5.401 5.305 5.474C4.857 5.546 4.552 5.969 4.625 6.417C4.698 6.866 5.12 7.17 5.569 7.098Z" fill="#fff" />
      <path d="M10.752 7.09C11.194 6.986 11.468 6.543 11.364 6.1C11.259 5.658 10.816 5.384 10.374 5.489C9.932 5.593 9.658 6.036 9.762 6.478C9.867 6.92 10.31 7.194 10.752 7.09Z" fill="#fff" />
    </svg>
  ),
  low: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.026 16C12.439 16 16.008 12.418 15.998 8C15.988 3.582 12.403 0 7.99 0C3.577 0 0.008 3.582 0.018 8C0.028 12.418 3.613 16 8.026 16Z" fill="#FF6600" />
      <path d="M10.899 10.9C10.762 10.9 10.624 10.848 10.519 10.744C10.052 10.283 9.066 9.985 8.008 9.985C6.95 9.985 5.965 10.283 5.498 10.744C5.285 10.953 4.942 10.952 4.731 10.739C4.521 10.526 4.523 10.183 4.737 9.973C5.416 9.303 6.639 8.903 8.008 8.903C9.377 8.903 10.6 9.303 11.28 9.973C11.493 10.183 11.495 10.526 11.285 10.739C11.179 10.846 11.039 10.9 10.899 10.9Z" fill="#fff" />
      <path d="M5.628 7.089C6.071 6.985 6.346 6.543 6.243 6.101C6.139 5.658 5.696 5.383 5.254 5.487C4.811 5.59 4.536 6.032 4.639 6.475C4.742 6.917 5.185 7.192 5.628 7.089Z" fill="#fff" />
      <path d="M11.222 6.792C11.503 6.434 11.439 5.917 11.081 5.637C10.722 5.357 10.205 5.421 9.925 5.779C9.645 6.137 9.708 6.654 10.067 6.933C10.425 7.213 10.943 7.15 11.222 6.792Z" fill="#fff" />
    </svg>
  ),
  vlow: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.018 16C12.426 16 15.992 12.418 15.982 8C15.972 3.582 12.39 0 7.982 0C3.574 0 0.008 3.582 0.018 8C0.028 12.418 3.61 16 8.018 16Z" fill="#EA0C42" />
      <path d="M11.014 11.579C11.305 11.509 11.484 11.217 11.414 10.926C11.041 9.377 9.638 8.294 8 8.294C6.362 8.294 4.985 9.326 4.587 10.922C4.514 11.212 4.691 11.505 4.981 11.578C5.025 11.589 5.069 11.594 5.112 11.594L11.014 11.579Z" fill="#fff" />
      <path d="M6.017 6.869C6.339 6.548 6.339 6.027 6.017 5.706C5.696 5.384 5.175 5.384 4.854 5.706C4.533 6.027 4.533 6.548 4.854 6.869C5.175 7.19 5.696 7.19 6.017 6.869Z" fill="#fff" />
      <path d="M10.694 7.1C11.142 7.028 11.447 6.606 11.375 6.157C11.303 5.709 10.881 5.404 10.432 5.476C9.983 5.548 9.678 5.971 9.751 6.419C9.823 6.868 10.245 7.173 10.694 7.1Z" fill="#fff" />
    </svg>
  ),
  none: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.018 16C12.426 16 15.992 12.418 15.982 8C15.972 3.582 12.39 0 7.982 0C3.574 0 0.008 3.582 0.018 8C0.028 12.418 3.61 16 8.018 16Z" fill="#979797" />
      <path d="M7 11.832V7.468C7 7.016 7.369 6.65 7.825 6.65C8.281 6.65 8.65 7.016 8.65 7.468V11.832C8.65 12.284 8.281 12.65 7.825 12.65C7.369 12.65 7 12.284 7 11.832Z" fill="#fff" />
      <path d="M7.825 4C8.281 4 8.65 4.369 8.65 4.825C8.65 5.281 8.281 5.65 7.825 5.65C7.369 5.65 7 5.281 7 4.825C7 4.369 7.369 4 7.825 4Z" fill="#fff" />
    </svg>
  ),
};

export const LEVELS = {
  vhigh: { key: 'vhigh', label: 'สูงมาก', color: '#0B9C23' },
  high: { key: 'high', label: 'สูง', color: '#3AC34B' },
  mid: { key: 'mid', label: 'ต้องลุ้น', color: '#FFB600' },
  low: { key: 'low', label: 'ต่ำ', color: '#FF6600' },
  vlow: { key: 'vlow', label: 'ต่ำมาก', color: '#EA0C42' },
  none: { key: 'none', label: 'ไม่มีข้อมูล', color: '#979797' },
};

export const pickLevel = (cur, estMin, estMax) => {
  if (cur > estMax) {
    if (cur - estMax > estMax * 0.15) return LEVELS.vhigh;
    return LEVELS.high;
  }
  if (cur < estMin) {
    if (estMin - cur > estMin * 0.15) return LEVELS.vlow;
    return LEVELS.low;
  }
  return LEVELS.mid;
};

const STYLES = `
.pass-chance {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  line-height: 0;
  cursor: pointer;
  outline: none;
}
.pass-chance-tip {
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 12px;
  border-radius: 14px;
  font-size: 0.82rem;
  font-weight: normal;
  line-height: 1.2;
  white-space: nowrap;
  filter: drop-shadow(0 6px 16px rgba(0, 0, 0, 0.12)) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.06));
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease;
  font-family: inherit;
}
.pass-chance:hover .pass-chance-tip,
.pass-chance:focus .pass-chance-tip,
.pass-chance:focus-within .pass-chance-tip {
  opacity: 1;
  visibility: visible;
}
.pass-chance-tip-gap {
  display: inline-block;
  width: 4px;
}
.pass-chance-tip-arrow {
  position: absolute;
  top: calc(100% - 1px);
  left: 50%;
  margin-left: -6px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid transparent;
}

.pass-chance--anchor-right .pass-chance-tip {
  left: auto;
  right: -8px;
  transform: none;
}
.pass-chance--anchor-right .pass-chance-tip-arrow {
  left: auto;
  right: 10px;
  margin-left: 0;
}

.pass-chance-vhigh .pass-chance-tip { background-color: #E6F5E9; color: #0B9C23; }
.pass-chance-vhigh .pass-chance-tip-arrow { border-top-color: #E6F5E9; }

.pass-chance-high .pass-chance-tip { background-color: #EAF8EC; color: #3AC34B; }
.pass-chance-high .pass-chance-tip-arrow { border-top-color: #EAF8EC; }

.pass-chance-mid .pass-chance-tip { background-color: #FFF6E0; color: #E6A800; }
.pass-chance-mid .pass-chance-tip-arrow { border-top-color: #FFF6E0; }

.pass-chance-low .pass-chance-tip { background-color: #FFEEE0; color: #FF6600; }
.pass-chance-low .pass-chance-tip-arrow { border-top-color: #FFEEE0; }

.pass-chance-vlow .pass-chance-tip { background-color: #FBE3EA; color: #EA0C42; }
.pass-chance-vlow .pass-chance-tip-arrow { border-top-color: #FBE3EA; }

.pass-chance-none .pass-chance-tip { background-color: #F2F2F2; color: #555; }
.pass-chance-none .pass-chance-tip-arrow { border-top-color: #F2F2F2; }
`;

let stylesInjected = false;
const ensureStyles = () => {
  if (stylesInjected || typeof document === 'undefined') return;
  const tag = document.createElement('style');
  tag.setAttribute('data-pass-chance', '');
  tag.textContent = STYLES;
  document.head.appendChild(tag);
  stylesInjected = true;
};

const PassChance = ({ score, project, anchorRight = false }) => {
  ensureStyles();

  const cur = Number(score);
  if (!Number.isFinite(cur)) return null;
  const estMin = Number(_.get(project, 'est_min_of_min_range'));
  const estMax = Number(_.get(project, 'est_max_of_min_range'));
  const hasEstimate = Number.isFinite(estMin) && Number.isFinite(estMax);

  if (!hasEstimate) {
    const level = LEVELS.none;
    const titleText = 'ไม่สามารถคำนวณโอกาสผ่านได้ เนื่องจากไม่มีข้อมูลของปีที่แล้ว';
    return (
      <span
        className={`pass-chance pass-chance-${level.key}${anchorRight ? ' pass-chance--anchor-right' : ''}`}
        tabIndex={0}
        title={titleText}
        aria-label={titleText}
        onClick={() => {
          // eslint-disable-next-line no-console
          console.log({ project });
        }}
      >
        {ICONS[level.key]}
        <span className="pass-chance-tip" role="tooltip">
          {'ไม่สามารถคำนวณโอกาสผ่านได้'}
          <br />
          {'เนื่องจากไม่มีข้อมูลของปีที่แล้ว'}
          <span className="pass-chance-tip-arrow" />
        </span>
      </span>
    );
  }

  const level = pickLevel(cur, estMin, estMax);
  const rangeValue = estMin === estMax ? `${estMin}` : `${estMin} - ${estMax}`;
  const titleText = `โอกาสผ่าน : ${level.label} ประมาณการคะแนนต่ำสุด : ${rangeValue}`;

  return (
    <span
      className={`pass-chance pass-chance-${level.key}${anchorRight ? ' pass-chance--anchor-right' : ''}`}
      tabIndex={0}
      title={titleText}
      aria-label={titleText}>
      {ICONS[level.key]}
      <span className="pass-chance-tip" role="tooltip">
        {'โอกาสผ่าน : '}
        <b>{level.label}</b>
        <br />
        {'ประมาณการคะแนนต่ำสุด : '}
        <b>{rangeValue}</b>
        <span className="pass-chance-tip-arrow" />
      </span>
    </span>
  );
};

export default PassChance;
